import { useCallback, useEffect, useRef, useState } from 'react';
import useUserMemory from '../use-user-memory';
import { tagService } from '../../queries/tag';

const useFlashcardByVideoAula = () => {
  const { memoryUserUuid } = useUserMemory();
  const userUuid = memoryUserUuid;
  const [externalId, setExternalId] = useState<string | null>(null);

  const [flashcards, setFlashcards] = useState<IFlashcardByVideoAulaResponse[]>(
    []
  );
  const [isLoading, setIsLoading] = useState(false);
  const currentRequestId = useRef<string | null>(null);

  const fetchFlashcards = useCallback(
    async (externalId: string) => {
      setExternalId(externalId);
      if (!userUuid || !externalId) return;

      const requestId = externalId;
      currentRequestId.current = requestId;

      try {
        setFlashcards([]);
        setIsLoading(true);
        const flashcards = await tagService.listByVideoAula(
          userUuid,
          externalId
        );

        if (currentRequestId.current !== requestId) {
          return;
        }

        setFlashcards(flashcards);
      } catch (error) {
        if (currentRequestId.current !== requestId) {
          return;
        }
        console.error(error);
        setFlashcards([]);
      } finally {
        if (currentRequestId.current === requestId) {
          setIsLoading(false);
        }
      }
    },
    [userUuid]
  );

  useEffect(() => {
    if (!userUuid || !externalId) return;

    fetchFlashcards(externalId);
  }, [userUuid, externalId, fetchFlashcards]);

  return {
    flashcards,
    fetchFlashcards,
    isLoading,
  };
};

export default useFlashcardByVideoAula;
